/**
 * Convert a jQuery Deferred object into a native Promise.
 */
export default function toNativePromise(jqDeferred) {
    return new Promise((resolve, reject) => {
        jqDeferred.then(resolve, reject);
    });
}
